import React, { useEffect, useState } from "react";
import { API_URL } from "../../../config";
import axios from "axios";
import CourseCard from "./CourseCard";
import { Form, InputGroup, Button, Dropdown, Spinner } from "react-bootstrap";
import Pagination from "../common/Pagination";
import { setCourses as setCoursesAction } from "../../../store/actions";
import { useDispatch, useSelector } from "react-redux";

const difficultyFilterOptions = [
  "All Levels",
  "Beginner",
  "Intermediate",
  "Advanced",
];

const CourseList = () => {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [difficultyFilter, setDifficultyFilter] = useState("All");
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecord, setTotalRecord] = useState(0);
  const level = ["All", "Beginner", "Intermediate", "Advanced"];
  const itemsPerPage = 10;
  const dispatch = useDispatch();
  const { courses: storedCourses } = useSelector((state) => state.courses);
  const fetchCourses = async () => {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    const authToken = userDetails?.data?.auth_token;
    setLoading(true);
    const params = {
      offset: currentPage * itemsPerPage,
      limit: itemsPerPage,
    };

    if (search) {
      params.search = search;
    }

    if (difficultyFilter !== "All") {
      params.difficulty = difficultyFilter;
    }
    try {
      const response = await axios.get(
        `${API_URL}/api/freshment_portal_apis/EduLearn/get_all_courses`,
        {
          params: params,
          headers: {
            Authorization: authToken,
          },
        },
      );
      console.log(response.data?.data);
      setCourses(response.data?.data || []);
      setTotalRecord(response.data?.totalRecords || 0);
      setTotalPages(Math.ceil(response.data?.totalRecords / itemsPerPage));
    } catch (error) {
      console.error("Error fetching courses:", error);
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    fetchCourses();
  };

  useEffect(() => {
    fetchCourses();
  }, [difficultyFilter, currentPage]);

  useEffect(() => {
    fetchCourses();
  }, [refreshTrigger]);

  useEffect(() => {
    const storedCourses = localStorage.getItem("courses");
    if (storedCourses) {
      dispatch(setCoursesAction(JSON.parse(storedCourses)));
    }
  }, [dispatch]);

  return (
    <div>
      {/* Header section with title and count */}
      <div className="row mb-4">
        <div className="col-12">
          <div className="d-flex justify-content-between align-items-center">
            <h3 className="mb-0">Available Courses ({totalRecord})</h3>
          </div>
        </div>
      </div>

      {/* Filters section */}
      {/* <div className="d-flex align-items-center flex-wrap search-job bg-white px-0 mb-4">
        <div className="col-xl-2 col-xxl-2 col-lg-2 col-sm-4 col-12 search-dropdown d-flex align-items-center">
          <Dropdown className="form-control border-0 style-1 h-auto">
            <Dropdown.Toggle
              as="div"
              className="fs-16 font-w500 text-primary d-flex align-items-center i-false"
            >
              {difficultyFilter}
              <i className="fas fa-angle-down text-primary scale5 ms-3"></i>
            </Dropdown.Toggle>
            <Dropdown.Menu className="dropdown-menu dropdown-menu-end mt-1">
              {difficultyFilterOptions.map((filter) => (
                <Dropdown.Item
                  key={filter}
                  onClick={() => setDifficultyFilter(filter)}
                  className="text-primary"
                >
                  {filter}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        </div>
        <div className="col-xl-2 col-xxl-2 col-lg-2 col-sm-4 col-12 search-dropdown d-flex align-items-center">
          <Dropdown className="form-control border-0 style-1 h-auto">
            <Dropdown.Toggle
              as="div"
              className="fs-16 font-w500 text-primary d-flex align-items-center i-false"
            >
              {"All Courses"}
              <i className="fas fa-angle-down text-primary scale5 ms-3"></i>
            </Dropdown.Toggle>
            <Dropdown.Menu className="dropdown-menu dropdown-menu-end mt-1">
              <Dropdown.Item className="text-primary">
                All Courses
              </Dropdown.Item>
              {storedCourses &&
                storedCourses.length > 0 &&
                storedCourses.map((course, index) => (
                  <Dropdown.Item key={index} className="text-primary">
                    {course.name}
                  </Dropdown.Item>
                ))}
            </Dropdown.Menu>
          </Dropdown>
        </div>
        <div className="col-xl-7 col-xxl-7 col-lg-7 col-12 d-md-flex job-title-search pe-0">
          <div className="input-group search-area">
            <input
              type="text"
              value={search}
              className="form-control h-auto"
              placeholder="Search course by name"
            />
            <span className="input-group-text">
              <Button className="btn btn-primary ">
                Search <i className="flaticon-381-search-2 ms-2" style={{ fontSize: '14px', verticalAlign: 'middle' }}></i>
              </Button>
            </span>
          </div>
        </div>{" "}
        <div className="col-xl-1 col-xxl-1 col-lg-1 col-12 d-flex align-items-center justify-content-lg-end justify-content-center">
          <button onClick={resetFilter} className="btn btn-danger ">
            Reset
          </button>
        </div>
      </div> */}
      <div className="mb-4">
        <div className="d-flex flex-wrap align-items-center gap-5">
          <div
            className="d-flex align-items-center"
            style={{
              backgroundColor: "white",
              borderRadius: "10px",
              width: "fit-content",
            }}
          >
            <div className="btn-group" role="group" style={{ gap: 3 }}>
              {level.map((item) => (
                <button
                  key={item}
                  className="btn btn-md"
                  style={
                    difficultyFilter === item
                      ? {
                          backgroundColor: "#ffa755",
                          borderRadius: "10px",
                          color: "white",
                          fontWeight: "bold",
                        }
                      : { backgroundColor: "white", borderRadius: "10px" }
                  }
                  onClick={() => setDifficultyFilter(item)}
                >
                  {item}
                </button>
              ))}
            </div>
          </div>

          <div className="flex-grow-1">
            <div className="input-group">
              <input
                type="text"
                className="form-control py-0"
                placeholder="Search courses by name..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                style={{ borderRadius: "10px 0 0 10px", height: "3.2rem" }}
              />
              <Button variant="primary btn-sm" onClick={fetchCourses}>
                <i className="fas fa-search"></i>
              </Button>
            </div>
          </div>
        </div>
      </div>
      {/* Courses grid */}
      {loading ? (
        <div className="text-center py-5">
          <Spinner animation="border" role="status" variant="primary">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
          <p className="mt-2">Loading courses...</p>
        </div>
      ) : courses.length > 0 ? (
        <div className="row">
          {courses.map((course, index) => (
            <CourseCard key={index} course={course} />
          ))}
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            totalRecord={totalRecord}
            handlePageChange={handlePageChange}
            itemsPerPage={itemsPerPage}
          />
        </div>
      ) : (
        <div className="col-12 text-center py-5">
          <div className="text-muted">
            <i className="fas fa-search fa-3x mb-3"></i>
            <h4>No courses found</h4>
            <p>Try changing your search criteria or filters</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default CourseList;
